/** Remove emoji glyphs from narrative display, including legacy saved text. */
export function plainText(text: string | null | undefined): string {
  return (text || '').replace(/[0-9#*]\uFE0F?\u20E3|[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}\uFE0F\u200D\u20E3]/gu, '')
}
